<template>
  <section ref="dressCodeRef" class="dresscode-wrapper">
    <h2 ref="tituloRef" class="titulo-script">Código de Vestimenta</h2>

    <div ref="iconoRef" class="icono-wrap">
      <img src="@/assets/etuqteta.avif" alt="Código de vestimenta elegante" />
    </div>

    <h3 ref="etiquetaRef" class="etiqueta">Formal </h3>

    <p ref="texto2Ref" class="texto">
      Llena de colores nuestra boda el color blanco queda reservado exclusivamente para la novia.<br />
    
      Favor de no utilizar colores similares a la siguiente paleta de colores.<br />     <img
      src="@/assets/paleta.png"
      alt="Paleta de colores"
      class="paleta-img"
    />
     Favor de no vestir de jeans, tenis o ropa casual.<br />
      Agradecemos vestir de manera formal y elegante.
    </p>

 

    <a
      ref="pinterestRef"
      href="https://pin.it/645gax1yh"
      target="_blank"
      class="btn-pinterest"
    >
      Ver ideas en Pinterest
    </a>
  </section>
</template>


<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'DressCodeElegante',
  setup() {
    const dressCodeRef = ref(null)
    const tituloRef = ref(null)
    const iconoRef = ref(null)
    const etiquetaRef = ref(null)
    const texto2Ref = ref(null)
    const pinterestRef = ref(null)

    onMounted(async () => {
      await nextTick()

      // 🔹 Estados iniciales (una sola vez)
      gsap.set(tituloRef.value, { y: -50, opacity: 0 })
      gsap.set(iconoRef.value, { scale: 0.7, opacity: 0 })
      gsap.set(etiquetaRef.value, { y: 40, opacity: 0 })
      gsap.set(texto2Ref.value, { x: 60, opacity: 0 })
      gsap.set(pinterestRef.value, { y: 40, opacity: 0 })

      gsap.timeline({
        scrollTrigger: {
          trigger: dressCodeRef.value,
          start: 'top 90%',          // 🔴 MÁS TARDE (clave para móvil)
          toggleActions: 'play none none none',
          once: true,
          invalidateOnRefresh: true
        },
        defaults: { ease: 'power3.out' }
      })
        .to(tituloRef.value, {
          y: 0,
          opacity: 1,
          duration: 0.9
        })
        .to(iconoRef.value, {
          scale: 1,
          opacity: 1,
          duration: 1.1
        }, '+=0.15')
        .to(etiquetaRef.value, {
          y: 0,
          opacity: 1,
          duration: 0.7
        }, '+=0.1')
        .to(texto2Ref.value, {
          x: 0,
          opacity: 1,
          duration: 0.8
        }, '+=0.1')
        .to(pinterestRef.value, {
          y: 0,
          opacity: 1,
          duration: 0.7
        }, '+=0.1')

      ScrollTrigger.refresh()
    })

    return {
      dressCodeRef,
      tituloRef,
      iconoRef,
      etiquetaRef,
      texto2Ref,
      pinterestRef
    }
  }
}

</script>

<style scoped>.dresscode-wrapper {
  background-color: #efe6dc;
  padding: 80px 24px;
  text-align: center;
  color: #7a5a35;
  max-width: 420px;
  margin: 0 auto;
}

/* TÍTULO SCRIPT */
.titulo-script {
  font-family: 'cursiva', cursive;
  font-size: 46px;
  margin-bottom: 20px;
  color: #7a5a35;
  -webkit-text-fill-color: #7a5a35; /* 🔴 CLAVE PARA MÓVIL */
}

/* ICONO */
.icono-wrap img {
  width: 140px;
  display: block;
  margin: 0 auto 24px;
}

/* ETIQUETA */
.etiqueta {
  font-family: 'Playfair Display', serif;
  font-size: 20px;
  letter-spacing: 1px;
  color: black;
  margin-bottom: 14px;
  text-transform: uppercase;
}

/* TEXTO */
.texto {
  font-family: 'Playfair Display', serif;
  font-size: 15px;
  color: black;
  line-height: 1.7;
  margin-bottom: 16px;
}

/* BOTÓN */
.btn-pinterest {
  display: inline-block;
  margin-top: 20px;
  padding: 10px 26px;
  border: 1px solid #7a5a35;
  color: #7a5a35;
  font-family: 'Playfair Display', serif;
  font-size: 14px;
  text-decoration: none;
  letter-spacing: 1px;
  transition: all 0.3s ease;
}

.btn-pinterest:hover {
  background-color: #7a5a35;
  color: #efe6dc;
}


/* ICONO */
.icono-wrap img {
  width: 140px;
  display: block;
  margin: 0 auto 24px;
}

/* ETIQUETA */
.etiqueta {
  font-family: 'Playfair Display', serif;
  font-size: 20px;
  letter-spacing: 1px;
  color: black;
  margin-bottom: 14px;
  text-transform: uppercase;
}

/* TEXTO */
.texto {
  font-family: 'Playfair Display', serif;
  font-size: 15px;
  color: black;
  line-height: 1.7;
  margin-bottom: 16px;
}

/* BOTÓN */
.btn-pinterest {
  display: inline-block;
  margin-top: 20px;
  padding: 10px 26px;
  border: 1px solid #7a5a35;
  color: #7a5a35;
  font-family: 'Playfair Display', serif;
  font-size: 14px;
  text-decoration: none;
  letter-spacing: 1px;
  transition: all 0.3s ease;
}
.paleta-img {
  width: 180px;
  margin: 16px auto 0;
  display: block;
}

.btn-pinterest:hover {
  background-color: #7a5a35;
  color: #efe6dc;
}
</style>
